<template>
  <edit></edit>
</template>

<script>
import edit from './start_adv_temp_edit.vue'
export default {
  name: 'b_app_start_adv_add',

  components: {
    edit
  }
}
</script>